<tools-menu></tools-menu>
<hr>

<alert-component *ngIf="_resourceService.alert" [message]="_resourceService.alert" type="danger">
</alert-component>

<loading-component *ngIf="_resourceService.loading"></loading-component>

<div class="tab-pane active" id="searchbyid">
  <div class="form-row">

    <div class="form-group col-md-12">
      <label>{{ 'PATNR' | translate}}</label>
      <div class="input-group mb-3">
        <input class="form-control" type="text" [value]="patnr" name="patnr" [(ngModel)]=patnr
          maxlength="10">
      </div>
    </div>
  </div>

  <div class="form-group row mt-4">
    <div class="form-group col-md-12">
      <button type="submit" class="btn btn-main-color btn-block" (click)="openModal()"
        [disabled]="!patnr">
        {{ 'GENERATE_PIN' | translate}}
      </button>
    </div>
  </div>

  <!--   <div class="form-group row mt-4">
    <div class="form-group col-md-6">
      <button type="submit" class="btn btn-main-color btn-block"
        (click)="sendpasstorolewithoutpass('consultant')">
        {{ 'MANDAR_MAILS_TO_consultant' | translate}}
      </button>
    </div>

    <div class="form-group col-md-6">
      <button type="submit" class="btn btn-main-color btn-block"
        (click)="sendpasstorolewithoutpass('assistant')">
        {{ 'MANDAR_MAILS_TO_assistant' | translate}}
      </button>
    </div>
  </div>
 -->

</div>




<!-- PIN GENERATOR Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="pinGeneratorModal" tabindex="-1" role="dialog"
  aria-labelledby="pinGeneratorModal" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div>{{ 'GENERATE_PIN' | translate}} {{ 'FOR' | translate}}</div>
        <h5 class="modal-title" id="pinGeneratorModal"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null; pin = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <form>
          <div class="form-group row">
            <label for="name" class="col-sm-3 col-form-label">{{ 'NAME' | translate}} *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="patient.name" name="name"
                [(ngModel)]=patient.name disabled>
            </div>
          </div>

          <div class="form-group row">
            <label for="lastname" class="col-sm-3 col-form-label">{{ 'LASTNAME' | translate}}
              *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="patient.lastname" name="lastname"
                [(ngModel)]=patient.lastname disabled>
            </div>
          </div>

          <div class="form-group row  margin-top">
            <label for="id" class="col-sm-3 col-form-label">{{ 'EMAIL' | translate}} *</label>
            <div class="col-sm-9">
              <input class="form-control" type="text" [value]="patient.email" name="email"
                [(ngModel)]=patient.email disabled>
            </div>
          </div>

          <div class="form-group row mt-4" *ngIf="!pin">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-main-color btn-block" (click)="generatePin()">
                {{ 'GENERATE' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" (click)="closeModal()">
                {{ 'CANCEL' | translate}}
              </button>
            </div>
          </div>

          <div class="text-center" id="pin" *ngIf="pin">
            <h2> {{ 'PIN' | translate}}</h2>
            <h2>
              <span class="badge rounded-pil bg-primary">{{pin}}</span>
            </h2>
          </div>

          <div class="form-group row mt-4" *ngIf="pin">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-main-color btn-block" (click)="print()">
                {{ 'PRINT' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" (click)="closeModal()">
                {{ 'CLOSE' | translate}}
              </button>
            </div>
          </div>


        </form>
      </div>
    </div>
  </div>